import { Col, DatePicker, Input, Row, Select, Space } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import EmptyContent from '../../../components/EmptyContent'
import {
  DATE_FORMAT_DEFAULT,
  ELECTRONIC_DOCUMENT_STATUS,
  ISO_DATE_FORMAT,
} from '../../../constants'

const { RangePicker } = DatePicker
const { Option } = Select

const STATUS_MAPPING = {
  [ELECTRONIC_DOCUMENT_STATUS.PENDING]: 'Chưa xử lý',
  [ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL]: 'Đã trình dự thảo',
  [ELECTRONIC_DOCUMENT_STATUS.KTAT_OFFICE_APPROVAL]: 'P.KTAT đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.KTAT_OFFICE_REJECTION]: 'P.KTAT hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL]: 'Trưởng đơn vị đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_REJECTION]: 'Trưởng đơn vị hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_KTAT_OFFICE_APPROVAL]: 'TP.KTAT đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_KTAT_OFFICE_REJECTION]: 'TP.KTAT hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.BOARD_OF_DIRECTOR_APPROVAL]:
    'Ban Giám đốc đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.BOARD_OF_DIRECTOR_REJECTION]:
    'Ban Giám đốc hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.ROLLBACK_TO_CREATOR]:
    'Từ chối — Trả về Người lập',
  [ELECTRONIC_DOCUMENT_STATUS.ROLLBACK_TO_LEADER]:
    'Từ chối — Trả về Trưởng đơn vị',
  [ELECTRONIC_DOCUMENT_STATUS.FLOW_LOCKED]: 'Đã khóa luồng trình ký',
  [ELECTRONIC_DOCUMENT_STATUS.FLOW_UNLOCK]: 'Đã mở lại luồng trình ký',
  [ELECTRONIC_DOCUMENT_STATUS.READY]: 'Chờ phát hành',
  [ELECTRONIC_DOCUMENT_STATUS.READY_REJECTION]: 'Đóng dấu lại',
  [ELECTRONIC_DOCUMENT_STATUS.RELEASE]: 'Đã phát hành',
}

const AdvanceFilterBlock = props => {
  const { electronicDocumentStore } = props

  const { queryParamsSignDocument } = electronicDocumentStore

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = queryString.parse(location.search)

  const onSearchTitle = title => {
    electronicDocumentStore.setQueryParamsSignDocument({
      ...queryParamsSignDocument,
      page: 0,
      title: title && title.trim(),
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: 0,
        size: 10,
        title: title ? title.trim() : null,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/archiving-n-distribution?${queryStringStringify}`)
  }
  const onChangeStatus = status => {
    electronicDocumentStore.setQueryParamsSignDocument({
      ...queryParamsSignDocument,
      page: 0,
      status: status,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: 0,
        size: 10,
        status: status,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/archiving-n-distribution?${queryStringStringify}`)
  }

  const onChangeDate = value => {
    electronicDocumentStore.setQueryParamsSignDocument({
      ...queryParamsSignDocument,
      page: 0,
      from_date: value ? moment(value[0]).format(ISO_DATE_FORMAT) : null,
      to_date: value ? moment(value[1]).format(ISO_DATE_FORMAT) : null,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: 0,
        size: 10,
        from_date: value ? moment(value[0]).format(ISO_DATE_FORMAT) : null,
        to_date: value ? moment(value[1]).format(ISO_DATE_FORMAT) : null,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/archiving-n-distribution?${queryStringStringify}`)
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Row type={'flex'} gutter={15}>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Tiêu đề</span>
            <Input.Search
              onSearch={value => onSearchTitle(value)}
              placeholder={'Tìm kiếm trình ký theo tiêu đề'}
              allowClear
              defaultValue={queryStringParse.title}
            />
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Trạng thái</span>
            <Select
              style={{ width: '100%' }}
              allowClear
              onChange={onChangeStatus}
              defaultValue={queryStringParse.status}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              notFoundContent={<EmptyContent />}
              optionFilterProp={'name'}
              placeholder={'Chọn trạng thái'}>
              {Object.keys(STATUS_MAPPING).map(statusKey => (
                <Option key={statusKey} value={statusKey} name={statusKey}>
                  {STATUS_MAPPING[statusKey]}
                </Option>
              ))}
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Ngày trình</span>
            <RangePicker
              onChange={onChangeDate}
              defaultValue={
                queryStringParse.from_date && queryStringParse.to_date
                  ? [
                      moment(queryStringParse.from_date),
                      moment(queryStringParse.to_date),
                    ]
                  : null
              }
              style={{ width: '100%' }}
              placeholder={['Từ ngày', 'Đến ngày']}
              format={[DATE_FORMAT_DEFAULT, DATE_FORMAT_DEFAULT]}
            />
          </Space>
        </Col>
      </Row>
    </div>
  )
}

AdvanceFilterBlock.propTypes = {}

export default inject('electronicDocumentStore')(observer(AdvanceFilterBlock))
